<template>
  <div class="competitor-selector">
    <h4 class="size-16 fw-600 text-dark mb-3">Paso 1: Selecciona un competidor</h4>
    <div v-if="loading" class="d-flex justify-content-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <div v-else-if="competitors.length === 0" class="bg-white p-3 rounder-8 border">
      <h4 class="size-14 fw-400 fst-italic text-secondary">
        No se encontraron competidores registrados.
      </h4>
    </div>
    <div v-else class="row g-3">
      <div
        v-for="(item, index) in competitors"
        :key="index"
        class="col-12 col-sm-6 col-md-4 col-lg-3"
      >
        <div
          class="competitor-card bg-white rounder-8 border p-3 cursor-pointer h-100"
          :class="{ 'competitor-card--selected': isSelected(item) }"
          @click="toggleSelect(item)"
        >
          <div class="d-flex flex-column align-items-center text-center h-100">
            <img
              :src="item.competitor_logo"
              :alt="item.competitor_name"
              class="rounder-8 mb-2"
              style="max-width: 100%; width: 120px; height: auto; max-height: 60px; object-fit: contain;"
            />
            <h5 class="size-14 fw-600 text-dark mb-0 mt-auto">{{ item.competitor_name }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompetitorSelector',
  props: {
    competitors: {
      type: Array,
      default: () => []
    },
    selectedCompetitor: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isSelected(item) {
      return this.selectedCompetitor && this.selectedCompetitor.id === item.id
    },
    toggleSelect(item) {
      if (this.isSelected(item)) {
        this.$emit('select', null)
      } else {
        this.$emit('select', item)
      }
    }
  }
}
</script>

<style scoped>
.competitor-card {
  transition: all 0.2s ease-in-out;
}
.competitor-card:hover {
  border-color: #00b386 !important;
  box-shadow: 0 0 0 1px #00b386;
}
.competitor-card--selected {
  border-color: #00b386 !important;
  box-shadow: 0 0 0 2px #00b386;
  background-color: #e6f9f3 !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
